import { render, staticRenderFns } from "./ArmFooter.vue?vue&type=template&id=6742aec8&scoped=true"
import script from "./ArmFooter.vue?vue&type=script&lang=js"
export * from "./ArmFooter.vue?vue&type=script&lang=js"
import style0 from "./ArmFooter.vue?vue&type=style&index=0&id=6742aec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742aec8",
  null
  
)

export default component.exports